<template>
  <section class="py-5" ref="counterSection">
    <div class="container text-center">
      <h2 class="display-4 mb-4 fw-bold">Empowering Connections Every Day</h2>
      <div class="row justify-content-center">
        <div
          v-for="(counter, index) in counters"
          :key="index"
          class="col-6 col-md-3 mb-4"
        >
          <div class="p-3 h-100 floating">
            <div
              class="icon icon-shape text-primary rounded-circle mb-3 mx-auto"
              style="background: none"
            >
              <i :class="counter.icon"></i>
            </div>

            <h3 class="fw-bold">
              <CountUp
                v-if="animate"
                :start-val="0"
                :end-val="counter.endVal"
                :duration="3"
              />
              <span v-if="counter.suffix">{{ counter.suffix }}</span>
            </h3>

            <p class="text-muted mb-0">{{ counter.label }}</p>
          </div>
        </div>
      </div>

      <p class="mt-2 text-muted">
        Our numbers tell the story - millions of secure, seamless transactions
        powering everyday life.
      </p>
    </div>
  </section>
</template>

<script>
import CountUp from "vue-countup-v2";

export default {
  name: "CounterSection",
  components: { CountUp },
  data() {
    return {
      animate: false, // start with counters hidden
      counters: [
        {
          endVal: 500000,
          suffix: "+",
          label: "Successful Transactions",
          icon: "ni ni-credit-card",
        },
        {
          endVal: 99.9,
          suffix: "%",
          label: "Uptime Reliability",
          icon: "ni ni-watch-time",
        },
        {
          endVal: 1000000,
          suffix: "+",
          label: "Satisfied Customers",
          icon: "ni ni-satisfied",
        },
        {
          endVal: 50,
          suffix: "+",
          label: "Integrated Services",
          icon: "ni ni-collection",
        },
      ],
    };
  },
  mounted() {
    // Watch when the counter section comes into view
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Restart the animation
          this.animate = false;
          this.$nextTick(() => {
            this.animate = true;
          });
        }
      });
    });

    observer.observe(this.$refs.counterSection);
  },
};
</script>
